module.exports = __webpack_public_path__ + "img/camera-02.d53e5bab.svg";